import { useAppDispatch } from '@/store/store-hooks'
import { AccountActions } from '@/account/store/slice'
import { useContext } from 'react'
import { AuthContext } from '@/context/auth-context'

export const useRefreshData = () => {
  const dispatch = useAppDispatch()

  const { userAccountData } = useContext(AuthContext)
  const canViewSubscriptionInfo = userAccountData?.canViewStripeSubscriptionInfo

  /**
   * Refreshes timely data that is needed for the application that could change frequently
   */
  const refreshTimelyData = (forceRefresh = false) => {
    // Only fetch data if user has access to view their subscription and billing info
    if (canViewSubscriptionInfo) {
      dispatch(AccountActions.refreshPaymentDetails({ forceRefresh: forceRefresh }))
    }
  }

  return { refreshTimelyData }
}
